<template>
	<form data-vv-scope="bankCustomerLogin">
		<div class="number-prefix">
			<p
				class="address-type-p text-center mx-auto"
				style="font-weight: bold"
				id="verification-para"
				data-test="bankCustomerLoginFormRadioPara1"
			>
				Login with:
			</p>
			<div class="row text-center">
				<div class="col-md-6  col-6 ">
					<label
						class="input-container verification-method"
						id="signUp-sms-otp"
						data-test="bankCustomerLoginFormRadioLabelPara1"
					>
						Account Number
						<input
							class="ml-2"
							type="radio"
							value="account"
							id="signUp-sms-otp-radio"
							name="verificationMethod"
							v-model="inputData"
							data-test="bankCustomerLoginFormRadioinput1"
						>
						<span class="checkmark"></span>
					</label>
				</div>
				<div class="col-md-6  col-6">
					<label
						class="input-container verification-method"
						id="signUp-email-otp"
						data-test="bankCustomerLoginFormRadioLabel1"
					>
						Card Number
						<input
							class="ml-2"
							type="radio"
							value="card"
							name="verificationMethod"
							id="signUp-email-otp-radio"
							v-model="inputData"
							data-test="bankCustomerLoginFormRadioInput2"
						>
						<span class="checkmark"></span>
					</label>
				</div>
			</div>
			<div v-show="inputData === 'account'">
			<input
				class="col-12 form-control login-signup-input"
				type="text"
				placeholder="Account Number"
				v-validate="accountValidation"
				data-ismobileonly="false"
				name="Account Number"
				v-model="accountNumber"
				:class="{ 'is-invalid': errors.has('bankCustomerLogin.Account Number') && showLoginError}"
				id="login-form-account-number"
				data-test="loginFormAccNoInput"
			>
			<div
				class="invalid-feedback"
				v-if="(errors.has('bankCustomerLogin.Account Number') && showLoginError)"
				id="login-form-acc-no-error"
				data-test="loginFormEmailInputError"
			>
				{{ errors.first('bankCustomerLogin.Account Number') }}
			</div>
			</div>
			<div v-show="inputData === 'card'">
				<input
					class="col-12 form-control login-signup-input"
					type="text"
					placeholder="Card Number"
					v-validate="cardValidation"
					data-ismobileonly="false"
					name="Card Number"
					v-model="cardNumberData"
					:class="{ 'is-invalid': errors.has('bankCustomerLogin.Card Number') && showLoginError}"
					id="login-form-card-number"
					data-test="loginFormCardInput"
				>
				<div
					class="invalid-feedback"
					v-if="(errors.has('bankCustomerLogin.Card Number') && showLoginError)"
					id="login-form-card-no-error"
					data-test="loginFormCardNoInputError"
				>
					{{ errors.first('bankCustomerLogin.Card Number') }}
				</div>
			</div>
			<!-- Password Input field and error-->
			<div class="col-12 p-0" v-if="!bankLoginOtpSend">
				<input
					v-validate="'required|min:6'"
					:class="(showLoginError &&
            errors.has('bankCustomerLogin.password'))?'is-invalid':''"
					class="form-control login-signup-input mt-2"
					data-ismobileonly="false"
					name="password"
					type="password"
					placeholder="Create New Password"
					id="bankCustomerLogin-password"
					v-model="password"
					autocomplete="off"
					ref="password"
					data-test="bankCustomerLoginFormPsswrdInput"
				>
				<div
					class="invalid-feedback"
					v-if="showLoginError"
					v-show="errors.has('bankCustomerLogin.password')"
					id="signup-password-error"
					data-test="bankCustomerLoginFormPasswrdInputError"
				>
					{{errors.first('bankCustomerLogin.password')}}
				</div>
			</div>
			<!--Confirm Password Input field and error-->
			<div class="col-12 p-0" v-if="!bankLoginOtpSend">
				<input
					v-validate="'required|confirmed:password'"
					:class="(showLoginError &&
                errors.has('bankCustomerLogin.confirmpassword'))?'is-invalid':''"
					class="form-control login-signup-input mt-2"
					name="confirmpassword"
					type="password"
					placeholder="Confirm Password"
					id="signup-confirm-password"
					autocomplete="off"
					v-model="confirmPassword"
					data-ismobileonly="false"
					data-test="bankCustomerLoginFormConfirmInput"
				>
				<div
					class="invalid-feedback"
					v-if="showLoginError"
					v-show="errors.has('bankCustomerLogin.confirmpassword')"
					id="signup-confirm-password-error"
					data-test="bankCustomerLoginFormConfirmInputError"
				>
					The password confirmation does not match.
				</div>
			</div>
			<signup-vendor-promotion-form :showSignUpError="showLoginError"
																																	v-if="!bankLoginOtpSend"
																																	:account="account"
																																	@updateVendorPromotionSignupData="setVendorPromotionSignupData($event)"
			/>
			<input
				class="col-12 form-control login-signup-input mt-2 mb-2"
				type="password"
				placeholder="Otp"
				data-ismobileonly="false"
				name="otp"
				v-model="otp"
				id="login-form-password"
				:class="{ 'is-invalid': errors.has('bankCustomerLogin.otp') && showLoginError}"
				v-validate="'required|min:6'"
				ref="otp"
				v-if="bankLoginOtpSend"
				data-test="loginFormPsswrdInput"
			>
			<div
				class="invalid-feedback"
				v-if="(errors.has('bankCustomerLogin.otp') && showLoginError)"
				id="login-form-password-error"
				data-test="loginFormPsswrdInputError"
			>
				{{ errors.first('bankCustomerLogin.otp') }}
			</div>
			<p class="terms"
						data-test="loginFormPara1"
						id="loginFormPara1"
						v-if="bankLoginOtpSend"
			>
				By continuing, you agree to
				<router-link to="/pages/terms"
																	data-test="loginFormLink1"
																	id="loginFormLink1">
					Terms and Conditions of Use
				</router-link>
				and
				<router-link to="/pages/privacy"
																	data-test="loginFormLink2"
																	id="loginFormLink2">
					Privacy Notice
				</router-link>.
			</p>
		</div>
		<button
			class="ripplelink btn col-12 blue-btn continue-btn mt-2"
			@click.prevent="action('bankCustomerLogin', false)"
			id="bank-login-form-send-otp-btn"
			data-test="bankLoginFormSendOtpBtn"
			v-if="!bankLoginOtpSend"
			:disabled="otpSendSuccess"
		>
			{{otpSendSuccess?'Sending OTP...': 'Send OTP'}}
		</button>
		<button
			class="ripplelink btn col-12 blue-btn continue-btn mt-2"
			@click.prevent="action('bankCustomerLogin', true)"
			id="bank-login-form-btn"
			data-test="bankLoginFormBtn"
			v-else
		>
			Login
		</button>
	</form>
</template>

<script>
import { authenticationApi } from '../../../../services/ApiServices/authenticationApi'
import SignupVendorPromotionForm from '../../signUp/widgets/SignupVendorPromotionForm'

export default {
	components: { SignupVendorPromotionForm },
	name: 'BankLoginForm',
	data () {
		return {
			bankLoginOtpSend: false,
			showLoginError: false,
			otpSendSuccess: false,
			inputData: 'account',
			accountNumber: '',
			cardNumberData: '',
			otp: '',
			password: '',
			confirmPassword: '',
			account: {
				income_slab: 'Choose Your Income Range',
				occupation: 'Choose Your Occupation',
				dob: ''
			}
		}
	},
	computed: {
		accountValidation () {
			if (this.inputData === 'account') {
				return 'required'
			}
			return ''
		},
		cardValidation () {
			if (this.inputData === 'card') {
				return 'required'
			}
			return ''
		},
		vendorPromotionFormError () {
			return (this.account.dob === '' && this.account.income_slab === 'Choose Your Income Range', this.account.occupation === 'Choose Your Occupation')
		}
	},
	methods: {
		action (scope, isLogin) {
			this.$validator.validateAll(scope).then((result) => {
				if (result && !this.vendorPromotionFormError) {
					this.otpSendSuccess = true
					this.showLoginError = false
					if (isLogin) {
						this.bankOtpVerify()
					} else {
						if (this.inputData === 'account') {
							this.bankCustomerLogin(this.accountNumber, '', this.password)
						} else if (this.inputData === 'card') {
							this.bankCustomerLogin('', this.cardNumberData, this.password)
						}
					}
				} else {
					this.otpSendSuccess = false
					this.showLoginError = true
				}
			})
		},
		bankCustomerLogin (accNo, cardNo, passwordData) {
			authenticationApi.bankAccountLoginOtpSend(accNo, cardNo, passwordData, this.account)
				.then(() => {
					this.bankLoginOtpSend = true
					// this.otp = res.data.message
				})
				.catch(() => {
					this.otpSendSuccess = false
					this.bankLoginOtpSend = false
				})
		},
		bankOtpVerify () {
			authenticationApi.bankAccountLoginOtpVerify(this.otp)
				.then(() => {
					this.$router.push('/')
				})
		},
		setVendorPromotionSignupData (accountData) {
			this.income_slab = accountData.income_slab
			this.occupation = accountData.occupation
			this.dob = accountData.dob
		}
	},
	watch: {
		inputData () {
			this.showLoginError = false
			this.otp = ''
			this.bankLoginOtpSend = false
			this.otpSendSuccess = false
			this.password = ''
			this.confirmPassword = ''
			this.account.income_slab = 'Choose Your Income Range'
			this.account.occupation = 'Choose Your Occupation'
			this.account.dob = ''
		}
	}
}
</script>

<style scoped>

</style>
